import { ProductType } from "../types/ProductType";
import { baseURL } from "../services/apiService";

export function pdsUrl(sku: string, site: string, lang: string) {
  return `${baseURL}/pdf/pds-${sku}-${site}-${lang}-a4.pdf`;
}

export function tdsUrl(productType: ProductType, site: string, lang: string) {
  return `${baseURL}/pdf/tds-${productType.path}-${site}-${lang}-a4.pdf`;
}
